import {Box, Link} from "@mui/material";
import {faKeySkeleton} from "@fortawesome/pro-duotone-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import NextLink from "next/link";

const ArticleGetPermissionsLink = (
    {
        doi,
        eISSN
    }: {
        doi: string;
        eISSN: string
    }
) => (
    <Box>
        <Link
            component={NextLink}
            target="_blank"
            href={`https://www.copyright.com/openurl.do?contentIdType=doi&issn=${eISSN}&contentID=${doi}`}
        >
            <SpanTypography fontSize={'.875rem'} mr={.25}>
                <FontAwesomeIcon
                    icon={faKeySkeleton}
                />
            </SpanTypography>
            <SpanTypography fontSize={'.8rem'}>
                Get Permission (article level)
            </SpanTypography>
        </Link>
    </Box>
);

export default ArticleGetPermissionsLink;